export const NeoTripTypeCells: React.FC<any> = ({value}) => {
  const isPickup = value === "Onward" || value === "Pickup";
  return (
    <span
      className={`flex items-center justify-center rounded-full px-3 py-1 text-sm font-medium
            ${isPickup ? "bg-green-100 text-green-700" : "bg-blue-100 text-blue-700"}
          `}
    >
      {isPickup ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="mr-1 h-4 w-4"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 4l-6 6h4v10h4V10h4l-6-6z" />
        </svg>
      ) : (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="mr-1 h-4 w-4"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M12 20l6-6h-4V4h-4v10H6l6 6z" />
        </svg>
      )}
      {value}
    </span>
  );
};
